var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHasASound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99386 0.0458353C7.8806 0.0778151 7.71691 0.145943 7.63013 0.197171C7.45534 0.300348 5.87341 1.49959 4.24319 2.76484L3.1836 3.58715L2.43813 3.5879C1.50527 3.58885 1.24521 3.6242 0.892804 3.79805C0.549765 3.96727 0.288273 4.22716 0.125141 4.5609L0 4.81701V7.67935V10.5417L0.125141 10.7978C0.277929 11.1104 0.529303 11.3709 0.838188 11.5368C1.19571 11.7287 1.46709 11.7702 2.37314 11.7709L3.16645 11.7716L5.3751 13.4175C6.67824 14.3887 7.65609 15.0917 7.76017 15.1321C7.88143 15.1793 8.0364 15.2004 8.25626 15.2C8.53539 15.1994 8.60772 15.1842 8.82614 15.0806C9.25186 14.8786 9.48898 14.5788 9.56932 14.1411C9.62062 13.8615 9.62593 1.45158 9.57489 1.09613C9.50748 0.626588 9.2727 0.274772 8.91307 0.10449C8.67636 -0.00759069 8.27386 -0.0332807 7.99386 0.0458353Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 10C12.0996 9.16667 12.7996 7 11.5996 5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 11C14.3542 9.83333 15.4107 6.8 13.5996 4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5996 12C16.3542 10.5 17.4107 6.6 15.5996 3",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasASound);
export default __webpack_public_path__ + "static/media/HasASound.9109d5cd032b3dd3bf908c9d191f1159.svg";
export { ForwardRef as ReactComponent };